// tabs/ThinkyBaaSOverview.jsx
import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheckCircle,
  faUsers,
  faLock,
  faBolt,
  faFileInvoiceDollar,
} from "@fortawesome/free-solid-svg-icons";

const dummyStats = [
  { title: "Verifications Processed", value: "10,43,106+", icon: faCheckCircle, color: "text-green-400" },
  { title: "Employers Served", value: "Thousands Worldwide", icon: faUsers, color: "text-blue-400" },
  { title: "Secure & Encrypted", value: "End-to-end encryption", icon: faLock, color: "text-yellow-400" },
  { title: "Fast Verification", value: "Seconds, not days", icon: faBolt, color: "text-purple-400" },
  { title: "Automated Payroll Integration", value: "Plug & play HRIS", icon: faFileInvoiceDollar, color: "text-red-400" },
];

const ThinkyBaaSOverview = () => {
  return (
    <div className="bg-gray-900 text-white p-2 space-y-2 min-h-screen">
      <section className="text-center space-y-4">
        <h1 className="text-lg lg:text-xl font-bold">Make Hiring, Cheaper. 💼</h1>
        <p className="text-gray-300 text-sm lg:text-sm max-w-2xl mx-auto">
          ThinkyBlockchain enables consumers to own verified employment and income credentials and share them instantly, free, and compliance-ready,
          saving millions of hours across the verification pipeline every year.
        </p>
        <div className="flex felx-row justify-center gap-4 mt-2 flex-wrap">
          <button className="w-32 text-sm bg-blue-500 hover:bg-blue-600 px-2 py-2 rounded-lg font-semibold transition">Get Started</button>
          <button className="w-32 text-sm bg-gray-700 hover:bg-gray-600 px-2 py-2 rounded-lg font-semibold transition">Talk to Sales</button>
        </div>
      </section>

      <section className="grid grid-cols-2 lg:grid-cols-3 gap-2 place-items-center">
        {dummyStats.map((stat, idx) => (
          <div
            key={idx}
            className="bg-gray-800 p-6 rounded-2xl flex flex-col items-start text-start shadow-lg hover:shadow-xl transition"
          >
            <FontAwesomeIcon icon={stat.icon} className={`text-lg lg:text-xl mb-2 ${stat.color}`} />
            <h3 className="text-sm lg:text-lg font-bold">{stat.value}</h3>
            <p className="text-gray-400">{stat.title}</p>
          </div>
        ))}
      </section>

      {/* Consumer-driven Verification Section */}
      <section className="space-y-6">
        <h2 className="text-xl lg:text-lg font-bold">The Power of Consumer-Driven Verification</h2>
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6 place-items-center">
          <div className="bg-gray-800 p-4 rounded-2xl shadow-lg">
            <h3 className="font-semibold text-lg mb-2">Consumers</h3>
            <p className="text-gray-300">
              Own your data and get instant access to verified employment and income credentials. Share securely in seconds, only when you allow it.
            </p>
          </div>
          <div className="bg-gray-800 p-4 rounded-2xl shadow-lg">
            <h3 className="font-semibold text-lg mb-2">Issuers</h3>
            <p className="text-gray-300">
              Plug into your HRIS/payroll to auto-issue verifiable credentials at scale, reducing verification overhead and staying compliance-ready.
            </p>
          </div>
          <div className="bg-gray-800 p-4 rounded-2xl shadow-lg">
            <h3 className="font-semibold text-lg mb-2">Verifiers</h3>
            <p className="text-gray-300">
              Verify employer-issued, cryptographically signed credentials in seconds. Reduce costs, improve decision speed, and stay FCRA-compliant.
            </p>
          </div>
        </div>
      </section>

      {/* Automated Verification Section */}
      <section className="space-y-6">
        <h2 className="text-lg lg:text-xl font-bold">Automate Verification Requests</h2>
        <p className="text-gray-300">
          Employees handle sharing themselves, eliminating endless manual requests. Your organization avoids delays while staying FCRA-compliant.
        </p>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 place-items-center">
          <div className="bg-gray-800 p-4 rounded-2xl shadow-lg">
            <h3 className="font-semibold mb-2">Real-Time Verification</h3>
            <p className="text-gray-300">
              Verify employer-issued credentials in seconds, eliminating manual outreach and improving accuracy.
            </p>
          </div>
          <div className="bg-gray-800 p-4 rounded-2xl shadow-lg">
            <h3 className="font-semibold mb-2">Unlock Instant Verification</h3>
            <p className="text-gray-300">
              Whether you are a CHRO automating inbound requests or a verifier integrating fast checks, modernize the verification stack with user-controlled credentials.
            </p>
          </div>
        </div>
      </section>

      {/* Employer Benefits Section */}
      <section className="space-y-6">
        <h2 className="text-lg lg:text-xl font-bold">Employers</h2>
        <p className="text-gray-300">
          Reduce verification costs by millions and reclaim thousands of hours through fast, dependable employment data verification for former, current, and prospective employees.
        </p>
        <p className="text-gray-300">
          Our all-in-one suite supports one-click background checks and automates employment and income verification for your employees.
        </p>
      </section>
    </div>
  );
};

export default ThinkyBaaSOverview;
